import {BarEvent, BarEventStatus} from "@uptime-com/uptimebar";
import {parseISO} from "date-fns";

import {CheckStateEventWindow} from "@/lib/queries/checks.ts";

const STATUS_MAP: Record<CheckStateEventWindow["status"], BarEventStatus> = {
  UP: BarEventStatus.UP,
  DOWN: BarEventStatus.DOWN,
  NO_DATA: BarEventStatus.NO_DATA,
};

export const mapUptimeBarEvents = (events: CheckStateEventWindow[], noDataStatus?: BarEventStatus): BarEvent[] =>
  events.map((e) => {
    const status = STATUS_MAP[e.status];
    return {
      start: parseISO(e.start),
      end: e.end ? parseISO(e.end) : undefined,
      status: noDataStatus && status === BarEventStatus.NO_DATA ? noDataStatus : status,
      details: e.detail ?? undefined,
      id: e.alert_id ?? undefined,
    };
  });
